import store from 'public/store'
import bus from 'public/utils/bus'
// import { API } from 'public/config'
import { getToken } from 'public/utils'
import { QtReportUserLogin } from '@/layout/utils/report-qt.js'

function getAccessToken ({ data }) {
  if (data && data.ticket && data.type === 'inline') {
    let ticket = data.ticket
    let service = encodeURIComponent(location.origin + '/#/')
    store.dispatch('caslogin', {
      ticket,
      service,
      gray: data.gray,
      password_expired: data.password_expired
    })
    QtReportUserLogin()
  } else if (!getToken()) {
    location.hash = '#/login'
  }
}

window.addEventListener('message', getAccessToken)


// function getAccessTokenByRedirect () {
//   // const match = location.href.match(/ticket=(.*)[&]*/)
//   // const ticket = match ? match[1] : ''
//   const url = window.location.hash
//   const params = new URLSearchParams(url.split('?')[1])
//   const ticket = params.get('ticket')
//   if (ticket) {
//     let service = encodeURIComponent(location.origin + '/#/')
//     store.dispatch('caslogin', {
//       ticket,
//       service,
//       gray: params.get('gray'),
//       password_expired: params.get('password_expired')
//     })
//     QtReportUserLogin()
//   } else if (!getToken()) {
//     // window.location = `${API.login}?logintype=kyeweb&service=${location.href}`
//     window.location = `${API.login}?logintype=kyeweb&inlineCopy=1&service=${location.href}`
//   }
// }

// token过期重新登录后，更新已打开的模块的会话标识。否则影响模块在线时长的统计
bus.$on('GLOBAL_SET_TOKEN', _ => {
  let time = Date.now() + ''
  let logs = store.state.tagsView.logs
  Object.keys(logs).forEach(v => {
    logs[v] = time
  })
})


// try {
//   // 谷歌浏览器版本
//   const version = +navigator.userAgent.replace(/^.*Chrome\/([\d]+).*$/, '$1')

//   if (version >= 142) {
//     const lookup = window.__ERPLOOKUP__ ? window.__ERPLOOKUP__.find(x => x.code === 'sys_login_white_list') : null
//     const hasAuth = lookup && lookup.value && lookup.value.length && lookup.value.find(v => (v.lookupValue === 'global' && +v.lookupCode === 1) || (v.lookupValue === 'user' && v.lookupCode === localStorage.ERPCacheFlag))
//     if (hasAuth) {
//       getAccessTokenByRedirect()
//     }
//   }
// } catch (e) {
//   console.error('[登录异常]', e)
// }




// WEBPACK FOOTER //
// ./src/layout/layout/setup/token.js